import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Main, Filter } from 'Containers';
import { NotificationDialog, LoadingPage } from 'Components';
import { ON_HAND_REPORT_LISTING_FORM_NAME } from 'Common/FormEnum';
import { errorToast } from 'Common/ToastHelper';
import {
  BidGroupEnum,
  OnHandReportListingEnum,
  SiteEnum,
} from 'Common/FieldEnum';
import {
  GenericEnum,
  PrintGroupByTypeEnum,
  ActiveStatusEnum,
} from 'Common/Constants/Enumeration/CommonEnum';
import { submitForm, resetForm } from 'State/forms/actions';
import {
  getAcctCategoryForCurrentSite,
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getVendorForCurrentSite,
} from 'State/filters/actions';
import { getIds } from 'Common/FormHelper';
import { clearTableSavedState } from 'Common/FormHelper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { setTableStates } from 'Common/UserSettings/state/actions';
import { getTableStates } from 'Common/UserSettings/helpers/helper';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { ReportGeneration } from 'Common/ObjectHelper';
import * as FilterSelectors from 'State/filters/selectors';

import { OnHandReportListingContainer } from './OnHandReportListing';
import { INITIAL_VALUES, BASE_URL } from '../../helper/listing';
import {
  setSelectedItemsSites,
  clearReportError,
  getAllSites,
  getOnHandItems,
  setSiteIds,
} from '../../state/actions';
import {
  printReportData,
  resetPrintResponse,
  clearPrintReportError,
} from '../../../commonState/actions';
import { PRINT_API_URL } from '../../helper/onHand';
import * as CommonPrintSelector from '../../../commonState/selectors';
import * as OnHandListingSelectors from '../../state/selectors';

class OnHandReport extends Component {
  static propTypes = {
    submitForm: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    getAcctCategoryForCurrentSite: PropTypes.func.isRequired,
    getBidGroupForCurrentSite: PropTypes.func.isRequired,
    getItemGroupForCurrentSite: PropTypes.func.isRequired,
    getVendorForCurrentSite: PropTypes.func.isRequired,
    printReportData: PropTypes.func.isRequired,
    resetPrintResponse: PropTypes.func.isRequired,
    setSelectedItemsSites: PropTypes.func.isRequired,
    clearReportError: PropTypes.func.isRequired,
    getAllSites: PropTypes.func.isRequired,
    getOnHandItems: PropTypes.func.isRequired,
    clearPrintReportError: PropTypes.func.isRequired,
    setSiteIds: PropTypes.func.isRequired,
    setTableStates: PropTypes.func.isRequired,
    allSitesData: PropTypes.array.isRequired,
    onHandItems: PropTypes.array.isRequired,
    printLoading: PropTypes.bool.isRequired,
    siteIds: PropTypes.array,
    itemIds: PropTypes.array,
    allTableStates: PropTypes.object.isRequired,
    printError: PropTypes.object,
    printData: PropTypes.string,
    emptyPrintResponse: PropTypes.string,
    itemStatus: PropTypes.string,
    printOptionsValue: PropTypes.number,
    bidGroup: PropTypes.number,
    itemGroup: PropTypes.number,
    accountCategory: PropTypes.number,
    vendorId: PropTypes.number,
    fetchingDropdown: PropTypes.bool,
    bidGroupDataError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    itemGroupDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    acctCategoryDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    vendorDataError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    loadingOnHandItemsError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    allSitesLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
  };

  static defaultProps = {
    itemStatus: ActiveStatusEnum.Active,
    bidGroup: GenericEnum.InitialFilterValue,
    itemGroup: GenericEnum.InitialFilterValue,
    accountCategory: GenericEnum.InitialFilterValue,
    vendorId: GenericEnum.InitialFilterValue,
    siteIds: [],
    itemIds: [],
  };

  static path = `${BASE_URL}`;
  siteReactTableRef = React.createRef();
  itemReactTableRef = React.createRef();

  state = {
    showNoDataModal: false,
  };

  handleClickViewFIFO = () => {
    const { setSelectedItemsSites, history } = this.props;
    const filteredItemIds = this.getFilteredSelectedItems();
    const filteredSiteIds = this.getFilteredSelectedSites();
    if (
      !filteredItemIds ||
      !filteredItemIds.length ||
      !filteredSiteIds ||
      !filteredSiteIds.length
    ) {
      this.setState({
        showNoDataModal: true,
      });
      return;
    }
    setSelectedItemsSites({
      [OnHandReportListingEnum.ItemIds]: filteredItemIds,
      [OnHandReportListingEnum.SiteIds]: filteredSiteIds,
    });
    history.push(`${BASE_URL}/fifo`);
  };

  handleClickTransactionDetails = () => {
    const { setSelectedItemsSites, history } = this.props;
    const filteredItemIds = this.getFilteredSelectedItems();
    const filteredSiteIds = this.getFilteredSelectedSites();
    if (
      !filteredItemIds ||
      !filteredItemIds.length ||
      !filteredSiteIds ||
      !filteredSiteIds.length
    ) {
      this.setState({
        showNoDataModal: true,
      });
      return;
    }
    setSelectedItemsSites({
      [OnHandReportListingEnum.ItemIds]: filteredItemIds,
      [OnHandReportListingEnum.SiteIds]: filteredSiteIds,
    });
    history.push(`${BASE_URL}/transactiondetails`);
  };

  getMainProps = () => {
    return {
      toolbox: {
        rightButtons: [
          {
            content: 'View FIFO',
            onClick: this.handleClickViewFIFO,
          },
          {
            content: 'Transaction Details',
            onClick: this.handleClickTransactionDetails,
          },
        ],
        shown: true,
      },
    };
  };

  handleSubmit = values => {
    const filteredItemIds = this.getFilteredSelectedItems(values);
    const filteredSiteIds = this.getFilteredSelectedSites(values);
    if (
      !values ||
      !filteredItemIds ||
      !filteredItemIds.length ||
      !filteredSiteIds ||
      !filteredSiteIds.length
    ) {
      this.setState({
        showNoDataModal: true,
      });
      return;
    }
    const input = {
      [OnHandReportListingEnum.LoadFIFORequestModel]: {
        [OnHandReportListingEnum.ItemIds]: filteredItemIds,
        [OnHandReportListingEnum.ShowAllDates]: true,
        [OnHandReportListingEnum.SiteIds]: filteredSiteIds,
      },
      [OnHandReportListingEnum.IsSummaryReport]: true,
      [OnHandReportListingEnum.SortBy]:
        values[OnHandReportListingEnum.PrintOptions],
    };
    this.props.printReportData(PRINT_API_URL, input);
  };

  handleClickPrint = () => {
    this.props.submitForm(ON_HAND_REPORT_LISTING_FORM_NAME);
  };

  componentDidUpdate(prevProps) {
    const { printData, clearReportError, clearPrintReportError } = this.props;

    if (
      errorToast(this.props, prevProps, 'printError') ||
      errorToast(this.props, prevProps, 'bidGroupDataError') ||
      errorToast(this.props, prevProps, 'itemGroupDataError') ||
      errorToast(this.props, prevProps, 'acctCategoryDataError') ||
      errorToast(this.props, prevProps, 'vendorDataError') ||
      errorToast(this.props, prevProps, 'loadingOnHandItemsError') ||
      errorToast(this.props, prevProps, 'allSitesLoadingError')
    ) {
      clearReportError();
      clearPrintReportError();
    }
    if (printData && printData !== prevProps.printData) {
      ReportGeneration(printData, 'On Hand Report');
      clearPrintReportError();
    }
  }

  componentDidMount() {
    const {
      getBidGroupForCurrentSite,
      getItemGroupForCurrentSite,
      getAcctCategoryForCurrentSite,
      getVendorForCurrentSite,
      getAllSites,
      getOnHandItems,
      itemStatus,
      bidGroup,
      itemGroup,
      accountCategory,
      vendorId,
    } = this.props;
    const filteredSiteIds = this.getFilteredSelectedSites();
    getBidGroupForCurrentSite(BidGroupEnum.AllOnly);
    getItemGroupForCurrentSite();
    getAcctCategoryForCurrentSite();
    getVendorForCurrentSite();
    getAllSites().then(() => {
      const Ids = getIds(this.props.allSitesData);

      const input = {
        [OnHandReportListingEnum.ItemStatus]:
          itemStatus === undefined ? ActiveStatusEnum.Active : itemStatus,
        [OnHandReportListingEnum.BidGroup]:
          bidGroup === undefined ? GenericEnum.InitialFilterValue : bidGroup,
        [OnHandReportListingEnum.ItemGroup]:
          itemGroup === undefined ? GenericEnum.InitialFilterValue : itemGroup,
        [OnHandReportListingEnum.AccountCategory]:
          accountCategory === undefined
            ? GenericEnum.InitialFilterValue
            : accountCategory,
        [OnHandReportListingEnum.VendorId]:
          vendorId === undefined ? GenericEnum.InitialFilterValue : vendorId,
        [OnHandReportListingEnum.SiteIds]: filteredSiteIds
          ? filteredSiteIds
          : Ids,
      };
      getOnHandItems(input);
    });
  }

  componentWillUnmount() {
    this.clearTableSavedState();
    toast.dismiss();
  }

  clearTableSavedState = () => {
    const { history, allTableStates, setTableStates } = this.props;
    clearTableSavedState(history, BASE_URL, allTableStates, setTableStates, [
      TableNamesEnum.ON_HAND_REPORT_SITE_GRID_TABLE,
      TableNamesEnum.ON_HAND_REPORT_ITEM_GRID_TABLE,
      TableNamesEnum.ON_HAND_REPORT_FIFO_TABLE,
      TableNamesEnum.ON_HAND_REPORT_TRANSACTION_DETAILS_TABLE,
    ]);
  };

  handleNoDataDialog = () => {
    const { emptyPrintResponse, resetPrintResponse } = this.props;
    this.setState({ showNoDataModal: false });
    emptyPrintResponse === GenericEnum.EmptyString && resetPrintResponse();
  };

  getFilteredSelectedItems = values => {
    const { itemIds, onHandItems } = this.props;
    const checkedUsageOrders = [];
    const dataObjs =
      this.itemReactTableRef && this.itemReactTableRef.current
        ? this.itemReactTableRef.current.getResolvedState()
        : { sortedData: onHandItems };
    _.forEach(dataObjs.sortedData, obj => {
      const id = obj[OnHandReportListingEnum.Id]
        ? obj[OnHandReportListingEnum.Id]
        : obj._original[OnHandReportListingEnum.Id];
      if (
        values &&
        values[OnHandReportListingEnum.ItemIds] &&
        values[OnHandReportListingEnum.ItemIds].indexOf(id) !== -1
      ) {
        checkedUsageOrders.push(id);
      } else if (itemIds.indexOf(id) !== -1) {
        checkedUsageOrders.push(id);
      }
    });
    return checkedUsageOrders;
  };
  getFilteredSelectedSites = values => {
    const { siteIds, allSitesData } = this.props;
    const checkedUsageOrders = [];
    const dataObjs =
      this.siteReactTableRef && this.siteReactTableRef.current
        ? this.siteReactTableRef.current.getResolvedState()
        : { sortedData: allSitesData };
    _.forEach(dataObjs.sortedData, obj => {
      const id = obj[SiteEnum.Id]
        ? obj[SiteEnum.Id]
        : obj._original[SiteEnum.Id];
      if (
        values &&
        values[OnHandReportListingEnum.SiteIds] &&
        values[OnHandReportListingEnum.SiteIds].indexOf(id) !== -1
      ) {
        checkedUsageOrders.push(id);
      } else if (siteIds.indexOf(id) !== -1) {
        checkedUsageOrders.push(id);
      }
    });
    return checkedUsageOrders;
  };
  render() {
    const { fetchingDropdown, emptyPrintResponse } = this.props;
    return fetchingDropdown ? (
      <LoadingPage />
    ) : (
      <Fragment>
        <Filter
          title={'Reports | On Hand'}
          style={{
            width: 400,
          }}
        />
        <Main {...this.getMainProps()} shouldNotUsePageWidth>
          <OnHandReportListingContainer
            onSubmit={this.handleSubmit}
            handleClickPrint={this.handleClickPrint}
            initialValues={{
              ...INITIAL_VALUES,
              [OnHandReportListingEnum.PrintOptions]: PrintGroupByTypeEnum.Item,
            }}
            siteReactTableRef={this.siteReactTableRef}
            itemReactTableRef={this.itemReactTableRef}
          />
        </Main>
        <NotificationDialog
          title={'Print Report'}
          showDialog={this.state.showNoDataModal}
          message={'Please check at least 1 item and site to Print Report.'}
          onOkClick={this.handleNoDataDialog}
        />
        <NotificationDialog
          title={'Print Report'}
          showDialog={emptyPrintResponse === GenericEnum.EmptyString}
          message={'No data available.'}
          onOkClick={this.handleNoDataDialog}
        />
      </Fragment>
    );
  }
}

const selector = formValueSelector(ON_HAND_REPORT_LISTING_FORM_NAME);
const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(
    getIsDirty(ON_HAND_REPORT_LISTING_FORM_NAME)(state)
  );

  return {
    printLoading: CommonPrintSelector.getPrintLoading(state),
    printError: CommonPrintSelector.getPrintError(state),
    printData: CommonPrintSelector.getPrintData(state),
    emptyPrintResponse: CommonPrintSelector.getEmptyPrintResponse(state),

    printOptionsValue: selector(state, [OnHandReportListingEnum.PrintOptions]),
    siteIds: selector(state, [OnHandReportListingEnum.SiteIds]),
    itemIds: selector(state, [OnHandReportListingEnum.ItemIds]),
    itemStatus: selector(state, [OnHandReportListingEnum.ItemStatus]),
    bidGroup: selector(state, [OnHandReportListingEnum.BidGroup]),
    itemGroup: selector(state, [OnHandReportListingEnum.ItemGroup]),
    accountCategory: selector(state, [OnHandReportListingEnum.AccountCategory]),
    vendorId: selector(state, [OnHandReportListingEnum.VendorId]),

    allTableStates: getTableStates(state),

    fetchingDropdown:
      FilterSelectors.getBidGroupDataLoading(state) ||
      FilterSelectors.getAcctCategoryDataLoading(state) ||
      FilterSelectors.getVendorDataLoading(state) ||
      FilterSelectors.getItemGroupDataLoading(state),

    bidGroupDataError: FilterSelectors.getBidGroupDataError(state),
    itemGroupDataError: FilterSelectors.getItemGroupDataError(state),
    acctCategoryDataError: FilterSelectors.getAcctCategoryDataError(state),
    vendorDataError: FilterSelectors.getVendorDataError(state),

    loadingOnHandItemsError: OnHandListingSelectors.getLoadingOnHandItemsError(
      state
    ),
    allSitesLoadingError: OnHandListingSelectors.getAllSitesLoadingError(state),
    allSitesData: OnHandListingSelectors.getAllSitesData(state),
    onHandItems: OnHandListingSelectors.getOnHandItems(state),
  };
};
const mapDispatchToProps = {
  submitForm,
  resetForm,
  getAcctCategoryForCurrentSite,
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getVendorForCurrentSite,
  printReportData,
  resetPrintResponse,
  setSelectedItemsSites,
  clearReportError,
  getAllSites,
  getOnHandItems,
  clearPrintReportError,
  setSiteIds,
  setTableStates,
};
export const OnHandReportContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(OnHandReport);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/onhandreport/containers/onhandreportlisting/OnHandReportListingContainer.js